// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { NumericInput } from '../../../atoms/NumericInput';
export var NumericInputCellStructure = function (_a) {
    var className = _a.className, value = _a.value, _b = _a.state, state = _b === void 0 ? 'default' : _b, placeholder = _a.placeholder, onChange = _a.onChange, onEnter = _a.onEnter, onBlur = _a.onBlur;
    return (React.createElement(Container, { className: className, as: 'td' },
        React.createElement(NumericInput, { value: value, state: state, placeholder: placeholder, onChange: onChange, onEnter: onEnter, onBlur: onBlur })));
};
//# sourceMappingURL=NumericInputCellStructure.js.map